import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          GOOSIFER FORUM
        </Link>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/category/1">About Goosifer</Link>
          <Link to="/category/2">Sightings</Link>
          <Link to="/category/3">Search Parties</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 